import { EntityTypeEnum, WorkspaceWindowTypeEnum } from '@mark43/cad-api';
import { useWorkspaceStore } from '../../panels/use-workspace-store';
import { assertNonNull } from '../../queues/utils/assert-non-null';

export function useUnitQueueWorkspacePanel() {
    const workspacePanels = useWorkspaceStore().getActivePanels();

    const foundUnitQueueWorkspacePanel = workspacePanels.find(
        (panel) =>
            panel.workspacePanelType === WorkspaceWindowTypeEnum.QUEUE.name &&
            panel.queue?.dataEntityType === EntityTypeEnum.UNIT.name
    );

    assertNonNull(
        foundUnitQueueWorkspacePanel,
        'Workspace for queue and entity type UNIT not found'
    );

    return foundUnitQueueWorkspacePanel;
}
